import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";
import { ActivatedRoute,NavigationExtras,Router } from "@angular/router";
import * as c3 from 'c3';

import {
    FvmsCommonService
    ,FvmsApiDtgDangerDriveService
} from "src/app/shared/service";
import {
    DtgListType
    ,PagingInfo
    ,DtgActionType
} from "src/app/shared/vo";

@Component({
    templateUrl: './dtg.analytics.drive.danger.stopHighRpm.detail.component.html'
    ,providers: []
})
export class DtgAnalyticsDriveDangerStopHighRpmDetailComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    @Input() dtgListType:DtgListType;
    @Input() dtgActionType:DtgActionType;
    @Input() dtgUnitId:string;
    @Input() dtgDriveRuleType:number;
    @Input() fvmsTripCnt:string;
    @Input() dtgRegDtFrom:string;
    DtgActionType = DtgActionType;
    pagingInfo:PagingInfo = new PagingInfo();
    listItem:any[];
    chart01:any;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
        ,private fvmsCommonService:FvmsCommonService
        ,private router: Router
        ,private fvmsApiDtgDangerDriveService:FvmsApiDtgDangerDriveService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();

        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                this.companyInfo = companyInfo;
                if(this.companyInfo.companyId !== companyInfo.companyId){
                    // 회사가 바뀌면 차량 목록이 다르므로 메인 페이지로 이동해야 함
                    let tmpParam = {
                        runtime:new Date().getTime()
                    };
                    let navigationExtras:NavigationExtras = {
                        queryParams:tmpParam
                    };
                    this.router.navigate(["/dtg/analytics/drive/danger/stophighrpm/main"],navigationExtras);
                }
            });
     }

    ngOnInit() {
        this.reloadListItem();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {
        
    }

    reloadListItem(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgDriveRuleType : this.dtgDriveRuleType
            ,dtgUnitId: this.dtgUnitId
            ,fvmsTripCnt: this.fvmsTripCnt
            ,dtgRegDtFrom: this.dtgRegDtFrom
        };
        this.fvmsApiDtgDangerDriveService.getListDangerDriveHisDetail(searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listItem = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                    this.reloadListItemForChart();
                }
            });
    }

    reloadListItemForChart(){
        let searchInfo = {
            companyId : this.companyInfo?.companyId || 0
            ,dtgDriveRuleType : this.dtgDriveRuleType
            ,dtgUnitId: this.dtgUnitId
            ,fvmsTripCnt: this.fvmsTripCnt
            ,dtgRegDtFrom: this.dtgRegDtFrom
        };
        let pagingInfo = new PagingInfo();
        pagingInfo.pageSize = 60*60*24;

        this.fvmsApiDtgDangerDriveService.getListDangerDriveHisDetail(searchInfo,pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    if(apiResponse.resultValue){
                        this.initChart1Opt();
                        let listItemChart = apiResponse.resultValue;
                        for(let a=0;a<listItemChart.length;a++){
                            let item = listItemChart[a];
                        }
                        this.chart01.load({
                            json:listItemChart
                            ,unload:true
                            ,keys:{
                                x:"dtgRegDt"
                                ,value:[
                                    "dtgRpm"
                                    ,"dtgCheckRpm"
                                ]
                            }
                        });
                    }
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItem();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    initChart1Opt(){
        let self = this;
        this.chart01 = c3.generate({
            bindto: '#chart-01'
            ,data: {
                json:[]
                ,keys:{
                    x:"dtgRegDt"
                    ,value:[
                        "dtgRpm"
                        ,"dtgCheckRpm"
                    ]
                }
                ,types:{
                    dtgRpm:"bar"
                    ,dtgCheckRpm:"line"
                }
                ,names:{
                    dtgRpm:"RPM"
                    ,dtgCheckRpm:"기준RPM"
                }
                ,type:"bar"
                ,onclick:(d,el) => {
                    console.log("click",d.id,d.value);
                }
                ,onmouseover:(d) => {
                }
            }
            ,axis:{
                x:{
                    type:"category"
                }
                ,y:{
                    min:700
                }
            }
            ,bar: {
                
            }
            ,tooltip:{
                // format:{
                //     name:function(name, ratio, id, idx){
                //         // console.log("tooltip",name, ratio, id, idx);
                //         return self.listCarUseCnt[idx].name;
                //     }
                // }
            }
            ,legend: {
                hide: true
            }
        });
    }

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }
}